import { render, staticRenderFns } from "./ProDetail.vue?vue&type=template&id=caa715ec&"
import script from "./ProDetail.vue?vue&type=script&lang=js&"
export * from "./ProDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports